import { useQuery } from "@tanstack/react-query";

import { AnalyticsStatsCardWithSeparator } from "components/analytics/display-card-with-separator";
import { AnalyticsStatsCardPlaceholderWithSeparator } from "components/analytics/placeholder-with-separator";
import { jobKeys } from "components/job/queries";
import { fetchReviewJobsCountForCoordinator } from "components/timesheet/dashboard/jobs-coordinating/api";

export function InReviewJobsCard() {
  const { data, isLoading } = useQuery({
    queryKey: jobKeys.inReviewCount(),
    queryFn: fetchReviewJobsCountForCoordinator,
  });

  if (isLoading) return <AnalyticsStatsCardPlaceholderWithSeparator />;
  return <AnalyticsStatsCardWithSeparator label="In Review" value={data} />;
}
